import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { Modal } from '../components/Modal.jsx';

export default function Categories() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ['categories'], queryFn: () => api('/api/categories') });
  const [editing, setEditing] = useState(null);
  const save = useMutation({
    mutationFn: p => p.id
      ? api(`/api/categories/${p.id}`, { method: 'PATCH', body: p.data })
      : api('/api/categories', { method: 'POST', body: p.data }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['categories'] }); setEditing(null); },
  });
  const del = useMutation({
    mutationFn: id => api(`/api/categories/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['categories'] }),
  });
  return (
    <>
      <div className="page-header">
        <h1>{t('categories.title')}</h1>
        <button className="btn btn-primary" onClick={() => setEditing({})}>{t('categories.add')}</button>
      </div>
      <table className="table">
        <thead><tr><th>{t('common.name')}</th><th>{t('categories.parent')}</th><th></th></tr></thead>
        <tbody>
          {data?.categories?.map(c => (
            <tr key={c.id}>
              <td>{c.name}</td>
              <td>{data.categories.find(p => p.id === c.parentId)?.name || '—'}</td>
              <td>
                <button className="btn btn-secondary btn-sm" onClick={() => setEditing(c)}>{t('common.edit')}</button>{' '}
                <button className="btn btn-danger btn-sm" onClick={() => window.confirm(t('common.confirmDelete')) && del.mutate(c.id)}>{t('common.delete')}</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {editing && (
        <Modal title={editing.id ? t('common.edit') : t('categories.add')} onClose={() => setEditing(null)}>
          <CategoryForm cat={editing} all={data?.categories || []} onSave={d => save.mutate({ id: editing.id, data: d })} onClose={() => setEditing(null)} saving={save.isPending} />
        </Modal>
      )}
    </>
  );
}

function CategoryForm({ cat, all, onSave, onClose, saving }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: cat.name || '', parentId: cat.parentId || '' });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  return (
    <form onSubmit={e => { e.preventDefault(); onSave({ ...form, parentId: form.parentId || null }); }}>
      <div className="field"><label>{t('common.name')}</label><input required value={form.name} onChange={e => set('name', e.target.value)} /></div>
      <div className="field"><label>{t('categories.parent')}</label>
        <select value={form.parentId} onChange={e => set('parentId', e.target.value)}>
          <option value="">—</option>
          {all.filter(x => x.id !== cat.id).map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
      </div>
      <div className="modal-actions">
        <button type="button" className="btn btn-secondary" onClick={onClose}>{t('common.cancel')}</button>
        <button type="submit" className="btn btn-primary" disabled={saving}>{t('common.save')}</button>
      </div>
    </form>
  );
}
